export default __webpack_public_path__ + "static/media/acer.369c6b00.png";